import { useState } from "react";
import style from "../../styles/pujaDetails.module.css";
import { WEB_ENGAGE } from "@utils/constants";
import { trackEvent } from "@utils/analytics/event-analytics";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";
import HeadingPuja from "./HeadingPuja";
const FaqPuja = ({
  data
}) => {
  const {
    t
  } = useTranslation();
  const [fQId, setFQId] = useState(0);
  if (data.Faqs?.length <= 0 || !data.Faqs) {
    return null;
  }
  return <div className={style.pujaSectionContainer} data-sentry-component="FaqPuja" data-sentry-source-file="FaqPuja.jsx">
      <HeadingPuja headline={t("frequently-asked-questions")} data-sentry-element="HeadingPuja" data-sentry-source-file="FaqPuja.jsx" />
      <div className={style.faqItemContainer}>
        {data.Faqs.map((e, i) => <EventFAQItem key={i.toString()} e={e} i={i} fQId={fQId} setFQId={setFQId} name_WE={data.name_WE} eventID={data?.urlExtension} deityType={data?.EventDeityTypes[0]?.DeityType?.name} />)}
      </div>
    </div>;
};
export default FaqPuja;
const EventFAQItem = ({
  e,
  i,
  fQId,
  setFQId,
  name_WE,
  deityType,
  eventID
}) => {
  return <>
      <div className={style.fqBx}>
        <div className={`${style.fqQuestion} ${fQId === i ? style.fqQActive : null} ${style.fQActive2}`}>
          {/* <span className={style.fqId}>{i < 9 ? `0${i + 1}` : `${i + 1}`}</span> */}
          {e.question}
          <span onClick={() => {
          trackEvent(WEB_ENGAGE.SCREEN_NAMES.EVENT_DETAILS + " " + WEB_ENGAGE.ITEM_NAMES.FAQ_BOX + " " + WEB_ENGAGE.EVENT_NAMES.ITEM_CLICKED, {
            [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.EVENT_DETAILS,
            [WEB_ENGAGE.EVENT_PROPERTIES.ITEM_NAME]: WEB_ENGAGE.ITEM_NAMES.FAQ_BOX,
            [WEB_ENGAGE.EVENT_PROPERTIES.FAQ_NAME]: e.question,
            [WEB_ENGAGE.EVENT_PROPERTIES.KRIYA_NAME]: name_WE,
            [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_DEITY_TYPE]: deityType,
            [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_URL_EXTENSION]: eventID
          });
          fQId !== i ? setFQId(i) : setFQId(null);
        }} style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center" // Vertically align the content in the middle
        }}>
            {fQId !== i ?
          // <AiOutlinePlus className={`${style.icon}`} />
          <ExpandMoreIcon /> :
          // <AiOutlineClose className={`${style.icon}`} />
          <ExpandLessIcon />}
          </span>
        </div>
        <Typography className={`${style.fqAnswer} ${fQId === i ? style.fqActive : null}`} data-sentry-element="Typography" data-sentry-source-file="FaqPuja.jsx">
          {e.answer}
        </Typography>
      </div>
    </>;
};